<template>
	<div class="container">
		<div class="background"></div>

		<div class="wrapper">
			
			<div class="row">&nbsp;</div>

			<div class="row">
				<div class="col-sm-4"></div>
				<div class="col-sm-4">
					<img src="../../assets/zoom-logo.png">
				</div>
				<div class="col-sm-4"></div>
		    </div>

		    <div class="row">&nbsp;</div>

			<fieldset>
				<!-- Error handling here -->
		    	<div class="alert alert-danger" role="alert" v-if="errors.length > 0">
					<ul>
						<li v-for="error in errors">{{ error }}</li>
					</ul>
				</div>	
				
				<!-- login form -->
			    <form v-on:submit.prevent="login">
			    	<legend class="form-title">Log in</legend>
			    	
			    	<div class="login-container">
						<div class="form-group">
						    <input type="email" class="form-control" v-model="email" placeholder="Email address">
						</div>

						<div class="form-group">
						    <input type="password" class="form-control" v-model="password"
						    placeholder="Password">
						</div>

						<div class="form-check">
							<div class="row">
								<div class="col-sm-6">
									<input type="checkbox" class="form-check-input">
								    <label class="form-check-label">Check me out</label>
								</div>

								<div class="col-sm-6">
									<!-- TODO: add link -->
									<a href="" class="link">Forgot password?</a>
								</div>
							</div>
						</div>

						<div class="form-group">
							<div class="row">&nbsp;</div>
							<button type="submit" class="btn btn-primary">Login</button>
							
							<!-- <router-link to="/register">
								<a>Register</a>	
							</router-link> -->
						</div>

			    	</div>
			    	
					<div class="row">&nbsp;</div>
						
					<!-- <div class="form-group">
						Or Sign in with 
						<a @click="signWithGoogle" title="sign with google"><i class="fab fa-google"></i></a>
						<a @click="signWithGoogle"><i class="fab fa-facebook"></i></a>
						<a @click="signWithFacebook"><i class="fab fa-github"></i></a>
					</div> -->
			    </form>
			    
			    <div class="register-section">
					<p>Not a member yet?</p>
					<router-link to="/register">
						<a class="btn btn-default">Sign up</a>	
					</router-link>
					
					<div class="row">&nbsp;</div>
				</div>
		    </fieldset>
		</div>
	</div>
</template>

<script>
import firebase from 'firebase';
import Footer from '../Footer';

export default {
	data() {
		return {
			email : '',
			password : '',
			errors : []
		}
	},
	methods : {
		login() {
			// Validate the fields
			this.errors = []
			
			//check if the fields are empty
			if(this.email === '') {
				this.errors.push('The email can not be empty')
			}

			if(this.password === ''){
				this.errors.push('The password can not be empty')
			}

			//check the regex for email
			if(!/\S+@\S+\.\S+/.test(this.email)) {
				this.errors.push('The email is not valid')
			}

			//check for minimum length of 6 characters
			if(this.password.length < 6) {
				this.errors.push('The length should be greater than 6')
			}
	
			if(this.errors.length) { return }

			firebase.auth().signInWithEmailAndPassword(this.email, this.password)
			.then(() => {
				// TODO: push to the dashboard
				this.$router.push('/dashboard')
			})
			.catch((error) => {
				this.errors.push(error.message);
			})
		},
		signWithGoogle() {
			var self = this
			console.log("sign with google")
			var provider = new firebase.auth.GoogleAuthProvider();

			firebase.auth().signInWithPopup(provider).then(function(result) {
			    self.$router.push('/dashboard');
			}).catch((error) => {
				console.log(error)
			})
		},
		signWithFacebook() {
			alert('Waiting for approval from Simen')
		}
	},
	components : {
		appFooter : Footer
	}
}
</script>

<style scoped>
@import '../../assets/css/stylesheet.css';

a {
	cursor: pointer;
}

.container {
	font-family: 'Gotham Pro';
	background-image : url('../../assets/images/lines-background.png');
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	background-size: 30%;
}

.background {
	width: 100%;
	height: 100%;
	top : 0;
	left : 0;
	bottom: 0;
	background-image: linear-gradient(to right,#042AB1,#012853);;
	position: absolute;
	z-index: -99999991;
}

.wrapper {
  margin-top: 3%;
  display: flex;
  align-items: center;
  flex-direction: column; 
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

fieldset {
	border-radius: 20px;
	width: 90%;
	max-width: 320px;
  	background: #ffffff;
  	position: relative;
  	box-shadow: 0px 1px 5px rgba(0,0,0,0.3);
}

.login-container {
	padding: 10px 20px 0px 20px;
}

.register-section {
	text-align: center;
	border-bottom-right-radius: 20px;
	border-bottom-left-radius: 20px;
	width: 100%;
}

.form-title {
	text-align: center;
	font-weight: 600;
}

::-webkit-input-placeholder {
   text-align: center;
}

:-moz-placeholder { /* Firefox 18- */
   text-align: center;  
}

.form-additional-stuff {
	font-size: 1em;
}

input[type='checkbox'] {
    width: 1em;
    height: 1em;
}

::-moz-placeholder {  /* Firefox 19+ */
   text-align: center;  
}

:-ms-input-placeholder {  
   text-align: center; 
}

.form-check {
	font-size: 0.8em;
}

.btn-primary {
	width: 100%;
	background-color: rgba(2, 41, 81, 0.98);
	border-radius: 50px;
}

.btn-default {
	width: 80%;
	background-color: rgba(210, 210, 210, 0.98);
	color: rgb(80, 80, 80) !important;
}

.register-section {
	background-color : rgb(244, 244, 244);
}

input {
	border-radius: 50px;
}

p {
	text-align: center;
}

.link {
	color: rgb(55, 201, 159);
}

.link:hover {
	color: rgb(55, 201, 159);
}

form {
	margin-top: 1em;
}
</style>


// WEBPACK FOOTER //
// src/components/authentication/Login.vue